import * as React from 'react';

import {Link} from '../../link/link';

type Props = {
    value?: {
        value: string;
        url: string;
        isHidden?: boolean;
    };
};

export function Url(props: Props) {
    if (!props.value) {
        return null;
    }

    const handleClick = (e: React.SyntheticEvent<any>) => {
        e.stopPropagation();
    };

    return (
        <Link
            newTab={true}
            href={props.value.url}
            size='small'
            variant='primary'
            onClick={handleClick}
            className='underline'
        >
            {props.value.value}
        </Link>
    );
}
